<template lang="pug">
  v-container()
    v-card.pa-12.theCircle.primary(shaped)
      v-row(justify="center" align="center")
        v-col(cols="12" sm="4")
          v-img( width="150"  src="../../assets/img/prayerhands.png" )
        v-col(cols="12" sm="8")
          .display-3.font-weight-black Prayer Circle
        
      h1 Our Prayers are for...
      v-row(justify="center")
        v-col(cols="12")
          v-list
            v-list-item(v-for="(person, i) in prayerList" :key="i")
             v-icon.mdi.mdi-christianity-outline.primary--text {{person}}
      v-row(justify="center")
        v-col(cols="12")
          v-card.pa-5(  )
            v-form(ref='form' v-model='valid' lazy-validation)
              v-row(justify="center")
                v-col(cols="12")
                  .body-1.font-italic
                    sup
                      v-icon.mdi.mdi-asterisk(x-small color="red" )
                    |  Indicates required field
              .subtitle-1 Name
              v-row(no-gutters)
                v-col(cols="12" sm="6")
                  v-text-field.pa-1(v-model='firstName'
                  :error-messages="firstNameErrors" :counter='10' 'required' label='First' @input="$v.firstName.$touch()" @blur="$v.firstName.$touch()")
                v-col(cols="12" sm="6")
                  v-text-field.pa-1(v-model='lastName', :error-messages="lastNameErrors" :counter='10', label='Last', 'required' @input="$v.lastName.$touch()" @blur="$v.lastName.$touch()")
              v-text-field(v-model='email' :error-messages="emailErrors" label='Email' 'required' @input="$v.email.$touch()" @blur="$v.email.$touch()")
              v-text-field(v-model='phone' :rules="phoneRules" :error-messages="phoneErrors" label='Phone' 'required' @input="$v.phone.$touch()" @blur="$v.phone.$touch()")
              v-select(v-model='category' :items='catagories' label='Catagory of Prayer')
              v-textarea(v-model='request' :counter='300', label='Requsting Prayer For...' height="70" 'auto-grow' @input="$v.email.$touch()" @blur="$v.email.$touch()")
            v-card-actions
              v-spacer
              v-btn(right color='primary', @click='onSubmit')
                | Submit Request
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
export default {
  mixins: [validationMixin],
  validations: {
    firstName: {
      required,
      maxLength: maxLength(20)
    },
    lastName: {
      required,
      maxLength: maxLength(20)
    },
    phone: {},
    email: { required, email },
    requestFor: {
      required,
      maxLength: maxLength(100)
    }
  },
  data() {
    return {
      valid: false,
      firstName: '',
      firstNameRules: [
        v => !!v || 'First Name is required',
        v => (v && v.length <= 20) || 'Name must be less than 20 characters'
      ],
      lastName: '',
      lastNameRules: [
        v => !!v || 'Last Name is required',
        v => (v && v.length <= 20) || 'Name must be less than 20 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      phone: '',
      phoneRules: [
        v =>
          /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/.test(v) ||
          'Phone Number must be valid'
      ],
      category: '',
      categoryRules: [v => !!v || 'A Category is required'],
      request: '',
      requestRules: [
        v => !!v || 'Please provide your Prayer Request',
        v =>
          (v && v.length <= 300) ||
          'The Request must be no more than 300 characters'
      ],

      catagories: [
        'Healing',
        'Encouragement',
        'Finances',
        'Relationship',
        'Family',
        'Depression/Suicide/Oppression',
        'Addiction',
        'Sexual Issues',
        'Grief',
        'Fear',
        'Hate',
        'Unforgiveness',
        'Stress',
        'Bitterness',
        'Shame',
        'Other'
      ],
      checkbox: false,
      prayerList: [
        'Mark Smith',
        'Jane Doe',
        'Chris Jones',
        'Sam Wilson',
        'Betty White',
        'Valerie Sams',
        'Denies Green',
        'Patircia Everret',
        'Dan King',
        'Billy Blane',
        'Daren Mitchell'
      ]
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    onSubmit() {
      console.log('Submitted');
    }
  },
  computed: {
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.maxLength &&
        errors.push('Name must be at most 20 characters long');
      !this.$v.firstName.required && errors.push('A First Name is required.');
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.maxLength &&
        errors.push('Name must be at most 20 characters long');
      !this.$v.lastName.required && errors.push('Name is required.');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.email.required && errors.push('Phone Number is required');
      return errors;
    }
    // phoneErrors() {
    //   const errors = [];
    //   if (!this.$v.phone.$dirty) return errors;
    // !this.$v.phone.email && errors.push('Must be valid phone number');
    // !this.$v.phone.required && errors.push('Phone Number is required');
    //   return errors;
    // }
  }
};
</script>

<style lang="stylus" scoped>
.required::after
  content ' * ' !important
  color red

.theCircle
  color var(--v-info-base)
</style>
